import { getIsBarcodeScannerEnabled } from '@app/ducks';
import { useModalVisibility } from '@app/utils/hooks';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Modal } from '../Modal';

import { ScannerContent } from './ScannerContent';

export const BarcodeScannerModal = () => {
  const { t } = useTranslation(['common']);

  const isBarcodeScannerEnabled = useSelector(getIsBarcodeScannerEnabled);
  const { isModalVisible, hideModal } = useModalVisibility('BarcodeScannerModal');

  if (!isBarcodeScannerEnabled) {
    return null;
  }

  return (
    <Modal title={t('common:scan_barcode')} isOpen={isModalVisible} onClose={hideModal} size="medium">
      <ScannerContent />
    </Modal>
  );
};
